import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';
import { type SectionTemplate as SchemaSectionTemplate } from '../schemas/SectionTemplate';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags SectionTemplate
 */
export const GetSectionTemplateVersionContentType = '' as const;
export type GetSectionTemplateVersionRequest = void;
export type GetSectionTemplateVersionResponses = LinkCommonErrorResponses & {
    /**
     * @description Content of a specific section template version
     */
    '200': {
        'application/json': SchemaSectionTemplate;
    };
    /**
     * @description Section template or version not found
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type GetSectionTemplateVersionResponseSuccess = GetSectionTemplateVersionResponses['200']['application/json'];
export type GetSectionTemplateVersionSearchParams = undefined;
export type GetSectionTemplateVersionPathParameters = {
    id: string;
    version_id: string;
};
export const GetSectionTemplateVersionUrl = '/section_template/{id}/versions/{version_id}' as const;
export const GetSectionTemplateVersionMethod = 'GET' as const;
export const getGetSectionTemplateVersionUrl = (params: GetSectionTemplateVersionPathParameters) =>
    GetSectionTemplateVersionUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GetSectionTemplateVersionPathParameters) =>
        String(params[param])
    );
